import { ContestVersioning } from './versioning/ContestVersioning';

export interface Contest extends ContestVersioning {
  startDate: Date;
  endDate: Date | null;
  versionId: number;
  participation: ContestParticipationMode;
  userMax: number;
  teamMax: number;
  armyListMax: number;
  showAllArmies: boolean;
}

export enum ContestParticipationMode {
  INDIVIDUAL = 0,
  TEAM = 1,
}
